import { render, staticRenderFns } from "./CreatePrealert.vue?vue&type=template&id=6f4fe76e"
import script from "./CreatePrealert.vue?vue&type=script&lang=js"
export * from "./CreatePrealert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports